
























































































import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import { Tooltip } from "element-ui";

import { FlowState } from "@/store/flow/state";
import CSS from "csstype";
import { ActionSelectSection } from "@/store/flow/actions/";
import { ISection } from "@/index.d";

import { createSection } from "@/util/data";
import HandlerMixin from "@/mixins/handler";
import GlobalMixin from "@/mixins/global";

type SelectSection = (payload: ActionSelectSection) => void;

@Component({
  components: {
    Tooltip,
  },
})
export default class Operator extends mixins(HandlerMixin, GlobalMixin) {
  @State("flow") public flow!: FlowState;
  @Action("flow/doubleClickHandler") private doubleClickHandler!: () => void;
  @Action("flow/addNewSectionInFrontCurrent") private addNewSectionInFrontCurrent!:
    (section: ISection) => void;
  @Action("flow/addNewSectionAtBackCurrent") private addNewSectionAtBackCurrent!:
    (section: ISection) => void;
  @Action("flow/moveSectionForward") private moveSectionForward!: () => void;
  @Action("flow/moveSectionBackward") private moveSectionBackward!: () => void;
  @Action("flow/removeSection") private removeSection!: () => void;
  @Action("flow/selectSection") private selectSection!: SelectSection;

  get height() {
    return this.flow.operatorStyle!.height;
  }

  get operatorTop() {
    return {
      top: this.flow.operatorStyle!.top,
    };
  }

  get operatorHeight() {
    return { height: this.height };
  }

  get isShow() {
    return Boolean(this.flow.operatorStyle);
  }

  get sectionIndex() {
    return this.flow.index;
  }

  get section() {
    return this.flow.section;
  }

  get length() {
    return this.flow.dataSource.length;
  }

  public onHandlerDoubleClick() {
    this.doubleClickHandler();
  }

  private onAddBtnClick(type: "top" | "bottom") {
    const section = createSection("static", "flow", "190px");
    if (type === "top") {
      this.addNewSectionInFrontCurrent(section);
    } else if (type === "bottom") {
      this.addNewSectionAtBackCurrent(section);
    }
  }

  private onMoveBtnClick(type: "forward" | "backward") {
    if (type === "forward") {
      this.moveSectionForward();
    } else if (type === "backward") {
      this.moveSectionBackward();
    }
  }

  private onRemoveBtnClick() {
    this.removeSection();
  }

  private onConfigurationClick() {
    if (this.section && this.sectionIndex > -1) {
      this.selectSection({ section: this.section, index: this.sectionIndex });
    }
  }
}
